import { useQuery } from '@tanstack/react-query';
import { api } from './api';

interface ApiDataResponse {
  data: any[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getApiDatas = async (integrationId: string, page: number = 1): Promise<ApiDataResponse> => {
  const { data } = await api.get(`/apiDatas/${integrationId}`, {
    params: { page, limit: 100 } // Get a larger chunk per page for the viewer
  });
  return data;
};

export const useApiDatas = (integrationId: string | null, page: number) => {
  return useQuery(
    ['apiDatas', integrationId, page],
    () => getApiDatas(integrationId!, page),
    {
      enabled: !!integrationId,
      keepPreviousData: true
    }
  );
};
